import React, { useState } from "react";

import { Button, Row } from "react-bootstrap";

import { ReactSVG } from "react-svg";

import { Participant } from "@api/graphql";
import { PenWriteEditIcon } from "@assets/icons";
import { AddBeneficiaryModal, Relation } from "@components/beneficiary/AddBeneficiaryModal";
import { ProtectedComponent } from "@components/permission_control/ProtectedComponent";
import { useAuthenticationContext } from "@context/authentication";
import { Role } from "@roles";

import styles from "./AddBeneficiaryButton.module.scss";

interface AddBeneficiaryButtonProps {
  participant: Participant;
  relation: Relation;
  refetchBeneficiary: () => void;
}

export const AddBeneficiaryButton = ({ participant, relation, refetchBeneficiary }: AddBeneficiaryButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { auth } = useAuthenticationContext();
  return (
    <ProtectedComponent requiredGroups={[Role.VisualArtistAdmin, Role.MemberServices]} auth={auth}>
      <Row>
        <Button
          key={`"add_beneficiary_"${relation?.root_artist?.node_id}`}
          variant="none"
          className={styles.addBeneficiaryButton}
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          <ReactSVG src={PenWriteEditIcon} />
          <span>Add/Edit Beneficiaries</span>
        </Button>

        {participant && relation && (
          <AddBeneficiaryModal
            participant={participant}
            relation={relation}
            isOpen={isModalOpen}
            refetchBeneficiary={refetchBeneficiary}
            onClose={() => {
              setIsModalOpen(false);
            }}
          />
        )}
      </Row>
    </ProtectedComponent>
  );
};
